<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'

const store = useStore()

const cutDryTornZoneDialog = computed(() => store.state.phreaticLine.cutDryTornZoneDialog)
const cutDryTornZoneLoading = computed(() => store.state.phreaticLine.cutDryTornZoneLoading)

const dialog = computed({
  get: () => cutDryTornZoneDialog.value,
  set: () => emit('toggle')
})

const emit = defineEmits(['onCut', 'toggle'])
</script>

<template>
  <v-dialog :model-value="dialog" max-width="600" @click:outside="emit('toggle')">
    <v-card>
      <v-card-title class="pt-4">Cut dry torn zone</v-card-title>

      <v-card-text class="pt-0 pl-4">
        The current soil composition will be cut by the dry torn zone. <br /><br />

        Are you sure you want to continue?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="cutDryTornZoneLoading"
          color="primary"
          text
          :disabled="cutDryTornZoneLoading"
          @click="emit('onCut')"
        >
          Cut
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
